var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1379 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m261 185.09c-8.897 2.533-18.289 3.889-27.998 3.889-56.348 0-102.03-45.679-102.03-102.03 0-10.055 1.454-19.77 4.164-28.947h-105.72c-16.249 0-29.422 13.173-29.422 29.422v202.16c0 16.249 13.173 29.422 29.422 29.422h202.16c16.249 0 29.422-13.173 29.422-29.422v-104.49z",
    clipRule: "evenodd",
    fill: "#ffffff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m319 72.5c0 40.041-32.46 72.5-72.5 72.5-40.041 0-72.5-32.459-72.5-72.5 0-40.041 32.459-72.5 72.5-72.5 40.04 0 72.5 32.459 72.5 72.5z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m628.43 206.74v110.07h45.71v-110.07c0-67.649-35.105-111.9-90.688-111.9-27.059 0-51.194 16.09-59.239 38.396v-35.836h-45.709v219.4h45.709v-109.7c0-38.762 21.575-66.553 51.195-66.553 32.179 0 53.022 25.963 53.022 66.187z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m704.69 206.74c0 63.628 47.172 112.26 107.87 112.26s107.51-48.634 107.51-112.26c0-63.261-46.806-111.9-107.51-111.9s-107.87 48.635-107.87 111.9zm107.87-66.187c35.104 0 61.799 28.523 61.799 66.187 0 38.03-26.695 66.553-61.799 66.553-35.105 0-62.165-28.523-62.165-66.553 0-37.664 27.06-66.187 62.165-66.187z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m984.94 50.958-10.971 46.441h-32.545v43.149h32.545v100.93c0 53.754 21.941 75.329 74.237 75.329h19.01v-45.343h-14.63c-22.67 0-32.91-9.874-32.91-32.545v-98.367h47.54v-43.149h-47.54v-46.441h-34.736z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1144.7 316.8v-219.4h-45.71v219.4h45.71z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1378.9 316.8v-219.4h-125.79v-16.09c0-22.672 10.24-32.911 32.91-32.911h14.62v-44.978h-19.01c-52.29 0-74.23 21.209-74.23 75.329v18.649h-32.18v43.149h32.18v176.26h45.71v-176.26h80.08v176.26h45.71z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m1116.6 0c-12.92 0-17.56 7.0891-17.56 17.171v36.651h35.83c12.45 0 17.99-4.357 17.99-16.644v-20.006c0-11.5-7.59-17.171-19.25-17.171h-17.01z",
    clipRule: "evenodd",
    fill: "#ffffff",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 290.28,
    x2: 220.61,
    y1: 11.299,
    y2: 145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7970",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB776",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiLogo);
export default __webpack_public_path__ + "static/media/notifi-logo.77f3c0b2051b1d4ed882328f3c883d1b.svg";
export { ForwardRef as ReactComponent };